import * as React from 'react';
import { ProgramBenefitsItem as TProgramBenefitsItem } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import * as styles from './program-benefits-item.module.scss';

type Props = {
  item: TProgramBenefitsItem;
};

const ProgramBenefitsItem: React.FC<Props> = ({ item }) => (
  <li className={styles.item}>
    <h3 className={styles.title}>
      <FormattedMessage message={item.title} />
    </h3>
    <p className={styles.description}>
      <FormattedMessage message={item.description} />
    </p>
  </li>
);

export { ProgramBenefitsItem };
